// Per-browser conveniences: starred and recently opened projects.
const read = (k) => {
  try {
    return JSON.parse(localStorage.getItem(k)) || [];
  } catch (e) {
    return [];
  }
};
const write = (k, v) => {
  try {
    localStorage.setItem(k, JSON.stringify(v));
  } catch (e) {
    /* storage unavailable */
  }
};

export const getStarred = () => read('gq-starred-projects');
export const isStarred = (id) => getStarred().includes(id);
export const toggleStar = (id) => {
  const cur = getStarred();
  const next = cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id];
  write('gq-starred-projects', next);
  window.dispatchEvent(new Event('gq-projects-changed'));
  return next.includes(id);
};
export const getRecent = () => read('gq-recent-projects');
export const touchRecent = (id) => {
  write('gq-recent-projects', [id, ...getRecent().filter((x) => x !== id)].slice(0, 6));
  window.dispatchEvent(new Event('gq-projects-changed'));
};
